<app-sidebar>
  <div class="toolbar-container">
    <app-toolbar />
  </div>
  <div class="main-container">
    <ng-content></ng-content>
  </div>
</app-sidebar>